import LoadingWrapper from 'components/LoadingWrapper';
import CoverWithOverlay from 'components/CoverWithOverlay/CoverWithOverlay';
import LayoutContainer from 'containers/Learn/Articles/LayoutContainer/LayoutContainer';
import sizes from 'style/sizes';
import { useParams } from 'react-router-dom';
import NotFound from 'containers/Errors/NotFound';
import { BodyText, Header2 } from 'components/UI/Brand/text';
import styled from 'styled-components';
import { useGetArticleQuery } from 'store/services/article';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

const Root = styled.div`
  max-width: ${sizes.articleContainerSize}px;
  position: relative;
  margin: 0 auto 32px auto;
`;
const HeaderText = styled(Header2)`
  margin: 20px 0;
`;
const IntroText = styled(BodyText)`
  padding: 0;
  font-weight: bold;
`;

const ArticleDetail = () => {
  const params = useParams();

  const {
    data: article,
    isLoading,
    isError,
    error,
  } = useGetArticleQuery({
    articleId: params.id,
  });

  if ((error as FetchBaseQueryError)?.status === 404) {
    return <NotFound />;
  }

  return (
    <LoadingWrapper loading={isLoading} error={isError}>
      <Root>
        <CoverWithOverlay
          mediaUrl={article?.hero}
          heroWithFocalPoint={article?.heroWithFocalPoint}
        />
        {!!article?.title && <HeaderText>{article?.title}</HeaderText>}
        {!!article?.intro && (
          <IntroText>{article?.intro as unknown as string}</IntroText>
        )}
        {article?.contentSection?.map(
          (
            {
              sections,
              title: articleTitle,
              description: articleDescription,
              layout,
              disclaimer,
              anchorLinks,
            },
            index
          ) => (
            <LayoutContainer
              key={`${articleTitle?.replaceAll(' ', '-')}-${index + 1}`}
              articles={sections}
              title={articleTitle}
              descriptionAsNode={articleDescription}
              layout={layout[0]}
              disclaimer={disclaimer}
              isArticle
              isUsingAnchorLinks={anchorLinks === 'True'}
              index={index}
            />
          )
        )}
      </Root>
    </LoadingWrapper>
  );
};

export default ArticleDetail;
